var _clipPath, _style, _fontFace, _missingGlyph, _glyph, _glyph2, _glyph3, _glyph4, _glyph5, _glyph6, _glyph7, _glyph8, _glyph9, _glyph0, _glyph1, _glyph10, _glyph11, _glyph12, _glyph13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXero = function SvgXero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "xero_svg__svg4443",
    width: 786.82,
    height: 786.82,
    viewBox: "0 0 208.179 208.179"
  }, props), /*#__PURE__*/React.createElement("defs", {
    id: "xero_svg__defs4437"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "xero_svg__clipPath18",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path16",
    d: "M0 850.394h850.394V0H0Z"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style71",
    type: "text/css"
  }, "@font-face{font-family:\"Arial Narrow\";src:url(#xero_svg__FontID0)format(svg)}")), /*#__PURE__*/React.createElement("font", {
    id: "xero_svg__FontID0",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 700,
    horizAdvX: 90,
    horizOriginX: 0,
    "horiz-origin-y": 0,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700
    },
    vertAdvY: 90,
    vertOriginX: 45,
    vertOriginY: 90
  }, _fontFace || (_fontFace = /*#__PURE__*/React.createElement("fontFace", {
    id: "xero_svg__font-face7",
    fontFamily: "Arial Narrow"
  })), _missingGlyph || (_missingGlyph = /*#__PURE__*/React.createElement("missingGlyph", {
    id: "xero_svg__missing-glyph9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path11",
    d: "M0 0"
  }))), _glyph || (_glyph = /*#__PURE__*/React.createElement("glyph", {
    id: "xero_svg__glyph13",
    horizAdvX: 228
  })), _glyph2 || (_glyph2 = /*#__PURE__*/React.createElement("glyph", {
    id: "xero_svg__glyph15",
    horizAdvX: 500,
    unicode: "L"
  }, /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path17",
    d: "M62.996 0v710h118.173V120.67h294.828V.001z"
  }))), _glyph3 || (_glyph3 = /*#__PURE__*/React.createElement("glyph", {
    id: "xero_svg__glyph19",
    horizAdvX: 774,
    unicode: "W"
  }, /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path21",
    d: "M142.504 0 2.497 715.836h121.501l87.83-491.667 107.507 491.667h141.168l102.996-500 90.338 500h119.158L630.338 0H504.336L387.17 535.171 271 0H142.504z"
  }))), _glyph4 || (_glyph4 = /*#__PURE__*/React.createElement("glyph", {
    id: "xero_svg__glyph23",
    horizAdvX: 456,
    unicode: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path25",
    d: "M55.166 0v715.836h112.83V336.002L299.33 518.495h138.671L292.497 329.169 448.163 0H327.165L219.67 232.83l-51.673-66.828V0H55.167z"
  }))), _glyph5 || (_glyph5 = /*#__PURE__*/React.createElement("glyph", {
    id: "xero_svg__glyph27",
    horizAdvX: 456,
    unicode: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path29",
    d: "m305.67 164.995 111.833-22.83c-15.001-52.167-38.336-90.831-69.84-115.995-31.667-25.338-69.992-37.832-115.16-37.832-62.831 0-111.34 20.991-145.668 62.995-40.33 48.838-60.5 117.165-60.5 204.995q0 130.005 61.003 208.007c34.493 43.998 79.158 65.996 133.831 65.996 60.828 0 108.668-22.502 143.161-67.496 39.672-51.333 59.503-127.174 59.503-227.498l-.504-15.67H141.672c.657-40.996 9.833-72.664 27.496-95.166C187.005 102 208.336 90.83 233.335 90.83c36.168 0 60.334 24.67 72.336 74.164zM312 303.666c-.997 40.329-9.67 70.836-25.832 91.17-16.337 20.334-35.664 30.496-58.166 30.496-23.663 0-43.833-10.666-60.007-31.832-16.665-21.495-24.823-51.334-24.495-89.834z"
  }))), _glyph6 || (_glyph6 = /*#__PURE__*/React.createElement("glyph", {
    id: "xero_svg__glyph31",
    horizAdvX: 500,
    unicode: "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path33",
    d: "M32.664 266.666c0 50.666 10.172 96.995 30.332 138.671 20.17 41.665 46.504 72.829 79.168 93.667 32.5 20.826 69.172 31.327 109.84 31.327 68.328 0 121.994-26.827 161.162-80.329 39.004-53.666 58.495-116.169 58.495-187.837 0-53.338-10.161-101.496-30.496-144.497-20.334-43-46.997-75.336-80-96.831-33.168-21.67-69.336-32.5-108.668-32.5-63.16 0-115.665 23.992-157.33 72.161-41.665 48.17-62.503 116.837-62.503 206.167zM148 259.329c0-52.494 10.161-92.166 30.67-118.994 20.5-26.838 45.334-40.164 74.33-40.164 28.327 0 52.494 13.49 72.664 40.493s30.332 66.839 30.332 119.673c0 51.334-10.326 90.502-30.825 117.658-20.509 27.003-45.004 40.504-73.671 40.504-28.34 0-52.67-13.501-73.004-40.504C158.163 350.839 148 311.331 148 259.33z"
  }))), _glyph7 || (_glyph7 = /*#__PURE__*/React.createElement("glyph", {
    id: "xero_svg__glyph35",
    horizAdvX: 456,
    unicode: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path37",
    d: "M429.668 365.161 318.832 340.83c-8.169 54.334-33.66 81.501-76.661 81.501-27.67 0-50.009-11.662-66.839-35.16-16.994-23.335-25.503-63.007-25.503-118.676 0-61.496 8.509-105 25.503-130.327 16.83-25.339 39.497-37.997 67.835-37.997 21.167 0 38.5 7.161 52.166 21.659 13.83 14.509 23.5 40.165 29.335 76.836l110.836-22.83C412.838 50.83 347.171-11.662 238.831-11.662c-69.335 0-120.834 26.324-154.33 78.994-33.496 52.834-50.337 116.333-50.337 190.498 0 88.838 18.998 156.509 56.83 202.838 38.008 46.33 87.678 69.664 149.173 69.664 49.833 0 90.502-13.162 121.83-39.66 31.503-26.336 54.005-68.176 67.67-125.51z"
  }))), _glyph8 || (_glyph8 = /*#__PURE__*/React.createElement("glyph", {
    id: "xero_svg__glyph39",
    horizAdvX: 228,
    unicode: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path41",
    d: "M59.163 588.838v126.998h112.676V588.838zM59.163 0v518.495h112.676V0z"
  }))), _glyph9 || (_glyph9 = /*#__PURE__*/React.createElement("glyph", {
    id: "xero_svg__glyph43",
    horizAdvX: 500,
    unicode: "n"
  }, /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path45",
    d: "M445.83 0H333.001v264.662c0 53.01-2.168 88.334-6.33 106.007-4.171 17.498-12.176 31-23.673 40.493-11.498 9.34-24.66 14.17-39.333 14.17-18.834 0-36.003-6.165-51.333-18.33-15.166-12.166-25.996-29.007-32.16-50.502-6.176-21.495-9.34-62-9.34-121.666V0H58.165v518.495h104.496v-76.158c18.506 29.324 39.333 51.334 62.667 65.996s49.002 21.999 77.34 21.999c32.993 0 60.663-8.662 83.33-25.667 22.666-17.17 38.172-39.168 46.833-65.996 8.673-26.838 12.998-65.667 12.998-116.333z"
  }))), _glyph0 || (_glyph0 = /*#__PURE__*/React.createElement("glyph", {
    id: "xero_svg__glyph47",
    horizAdvX: 456,
    unicode: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path49",
    d: "M142.996 360.332 40.997 382.834c12.34 52.33 32.84 89.998 61.331 112.993 28.503 23.006 69.336 34.504 122.837 34.504 47.501 0 83.834-6.669 108.832-19.995 24.999-13.501 43-31.503 53.666-54.498 10.84-23.006 16.173-64.671 16.173-125.334l-1.007-160.166c0-44.84 1.84-78.337 5.333-100.335 3.668-21.835 10.336-45.333 20.005-70.004h-111.34l-14.662 56.667c-19.162-22.831-39.66-39.837-61.67-51.334-21.999-11.333-45.333-16.994-70.157-16.994-41.336 0-75.172 13.83-101.507 41.664S29.334 94.837 29.334 141.167c0 29.171 5.333 54.838 15.998 76.661 10.83 21.835 25.996 39.169 45.498 52.166 19.502 13.009 50.84 24.67 93.666 34.668 52.166 12.001 88.498 23.335 109.007 33.671 0 28.668-2.004 47.502-6.176 56.503-3.996 8.825-11.497 16.162-22.491 21.834-10.84 5.825-26.17 8.661-46.001 8.661-20.334 0-36.168-4.664-47.666-13.665-11.508-9.165-21.002-26.17-28.174-51.334zm150.508-111.329c-14.334-5.836-36.672-12.67-67.003-20.498-34.832-9.177-57.499-19.174-68.34-30.343-10.665-10.994-15.997-25.327-15.997-42.825 0-19.842 5.836-36.672 17.673-50.173 12.001-13.502 26.828-20.16 44.83-20.16 15.833 0 31.667 5.333 47.336 16.327 15.495 10.84 26.335 23.838 32.5 38.84 6 14.99 9.001 42.157 9.001 81.49z"
  }))), _glyph1 || (_glyph1 = /*#__PURE__*/React.createElement("glyph", {
    id: "xero_svg__glyph51",
    horizAdvX: 500,
    unicode: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path53",
    d: "M449.17 0h-105v76.168C327 46.833 306.666 24.835 283.167 10.337c-23.334-14.673-47.5-21.999-72.171-21.999-47.666 0-88.991 23.663-124.327 71C51.333 106.664 33.67 174.335 33.67 262.165c0 88.674 17.334 155.337 51.826 200.506 34.504 44.994 77 67.66 127.338 67.66 23.828 0 46.001-6 66.664-18.166 20.663-12 39.672-30.003 57.006-54.17v257.84H449.17zM148.997 270.498c0-46.833 3.833-81.83 11.837-104.66 8.004-23.006 19.502-40.34 34.164-51.837 14.837-11.498 31.503-17.334 50.173-17.334 24.66 0 46.165 13.337 64.332 40 18.33 26.663 27.33 67.003 27.33 120.67 0 59.49-8.836 102.491-26.498 128.662-17.838 26.17-40.34 39.333-67.671 39.333-25.996 0-48.159-12.834-66.336-38.665-18.33-25.667-27.33-64.331-27.33-116.169z"
  }))), _glyph10 || (_glyph10 = /*#__PURE__*/React.createElement("glyph", {
    id: "xero_svg__glyph55",
    horizAdvX: 318,
    unicode: "r"
  }, /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path57",
    d: "M166.999 0H54.17v518.495h104.496v-73.66c18.002 34.503 34 57.334 48.17 68.667 14.168 11.169 30.495 16.83 49 16.83 25.667 0 50.327-8.661 73.826-25.995l-35.16-119.498c-18.67 14.826-36.169 22.327-52.835 22.327-15.67 0-29.335-5.661-41.172-17.334-11.99-11.498-20.498-32.336-25.667-62.667-5.157-30.332-7.829-86.002-7.829-167z"
  }))), _glyph11 || (_glyph11 = /*#__PURE__*/React.createElement("glyph", {
    id: "xero_svg__glyph59",
    horizAdvX: 272,
    unicode: "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path61",
    d: "M253.504 518.495V409.17h-76.672V200.167c0-45.169.996-71.504 3.34-78.5 4.49-13.163 13.83-19.667 27.824-19.667 10.5 0 25.338 4.5 45.004 13.162l9.67-106.325c-26.007-13.666-55.507-20.498-88.335-20.498-28.667 0-51.673 6.832-68.832 20.498C88.17 22.503 76.672 42.169 70.836 67.836c-4.665 18.998-6.833 57.334-6.833 115.337V409.17H12.165v109.325h51.838v103.17l112.829 80.002V518.496z"
  }))), _glyph12 || (_glyph12 = /*#__PURE__*/React.createElement("glyph", {
    id: "xero_svg__glyph63",
    horizAdvX: 638,
    unicode: "w"
  }, /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path65",
    d: "M138.671 0 3.832 518.495h109.5l79.497-339.823 73.333 339.823h108.34l70.835-339.823 81.501 339.823h110.825L500.996 0h-108l-73.168 333.505L247.503 0z"
  }))), _glyph13 || (_glyph13 = /*#__PURE__*/React.createElement("glyph", {
    id: "xero_svg__glyph67",
    horizAdvX: 456,
    unicode: "y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path69",
    d: "M5.333 518.495h120.166l101.003-368.162 99.667 368.162h116.169L292.498 19.502l-28.832-97.17c-12.669-36.497-25.327-63.16-37.832-80.001-12.505-16.995-28.503-29.992-47.83-39.169-19.337-9-43.165-13.665-71.503-13.665-21.835 0-43.165 2.836-64.003 8.333L32.665-94.663c17.673-4.336 33.332-6.34 47.337-6.34 21.495 0 39.168 7.172 52.998 21.341 13.83 14.323 25.163 40.494 34 78.162z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "xero_svg__layer1",
    transform: "translate(-5.887 -271.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "xero_svg__g10",
    transform: "matrix(.35278 0 0 -.35278 -39.93 525.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "xero_svg__g12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "xero_svg__g14",
    clipPath: "url(#xero_svg__clipPath18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path20",
    d: "M424.933 130.843c162.335 0 293.932 131.597 293.932 293.933 0 162.334-131.597 293.932-293.932 293.932S131 587.11 131 424.776c0-162.336 131.598-293.933 293.933-293.933",
    style: {
      fill: "#1ab4d7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path22",
    d: "m271.701 425.625 50.162 50.286a8.98 8.98 0 0 1 2.591 6.319c0 4.96-4.032 8.988-8.992 8.988a8.9 8.9 0 0 1-6.389-2.676c-.005-.01-50.117-50.093-50.117-50.093l-50.341 50.168a8.99 8.99 0 0 1-6.345 2.601c-4.954 0-8.987-4.026-8.987-8.981 0-2.417.965-4.685 2.697-6.394l50.155-50.148-50.129-50.223c-1.762-1.735-2.723-4.008-2.723-6.436 0-4.959 4.033-8.982 8.987-8.982 2.394 0 4.65.929 6.345 2.625l50.263 50.195 50.072-50.012c1.776-1.836 4.067-2.814 6.512-2.814 4.955 0 8.987 4.029 8.987 8.988a8.92 8.92 0 0 1-2.614 6.336z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path24",
    d: "M569.906 425.64c0-9.006 7.323-16.332 16.34-16.332 8.996 0 16.322 7.326 16.322 16.332 0 9.008-7.326 16.333-16.322 16.333-9.017 0-16.34-7.325-16.34-16.333",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path26",
    d: "M538.93 425.632c0 26.08 21.216 47.3 47.299 47.3 26.07 0 47.291-21.22 47.291-47.3 0-26.074-21.221-47.285-47.291-47.285-26.083 0-47.299 21.211-47.299 47.285m-18.606 0c0-36.334 29.565-65.895 65.905-65.895 36.339 0 65.919 29.561 65.919 65.895 0 36.339-29.58 65.908-65.919 65.908-36.34 0-65.905-29.569-65.905-65.908",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path28",
    d: "m515.646 490.413-2.765.008c-8.301 0-16.307-2.618-22.994-7.771-.881 4.032-4.485 7.066-8.778 7.066a8.887 8.887 0 0 1-8.912-8.91l.03-111c.013-4.942 4.044-8.959 8.988-8.959 4.943 0 8.973 4.017 8.986 8.97l.004 68.251c0 22.748 2.08 31.935 21.566 34.37 1.801.224 3.76.189 3.768.189 5.332.183 9.121 3.847 9.121 8.799 0 4.955-4.045 8.987-9.014 8.987",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "xero_svg__path30",
    d: "M343.072 436.482c0 .246.019.502.031.755 5.218 20.627 23.899 35.891 46.147 35.891 22.517 0 41.369-15.639 46.32-36.646zm110.903 1.697c-3.873 18.337-13.912 33.399-29.199 43.072-22.346 14.187-51.854 13.402-73.438-1.947-17.606-12.525-27.769-33.014-27.769-54.12 0-5.292.638-10.634 1.966-15.892 6.648-26.152 29.13-45.949 55.934-49.23 7.954-.963 15.696-.502 23.713 1.574a64.9 64.9 0 0 1 19.697 8.406c6.375 4.098 11.701 9.502 16.859 15.971.104.119.209.224.313.349 3.58 4.44 2.916 10.754-1.018 13.768-3.318 2.543-8.888 3.574-13.271-2.039a61 61 0 0 0-3.15-4.104c-3.485-3.851-7.809-7.582-12.99-10.476a47.3 47.3 0 0 0-22.093-5.58c-26.142.291-40.131 18.539-45.107 31.564a47.3 47.3 0 0 0-2.006 7.553c-.061.486-.106.955-.124 1.387l93.812.015c12.861.27 19.783 9.348 17.871 19.729",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))))));
};
export default SvgXero;